export default "__VITE_ASSET__C4b6xtz4__"